/* Bego Theme Premium — motion, immersive sections and conversion helpers (original code) */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var design = !!(window.Shopify && window.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in window;
  var animate = !reduced && !design && hasIO;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; });
  }
  function clamp(n, a, b) { return Math.min(b, Math.max(a, n)); }
  function store(key, val, session) {
    try {
      var st = session ? window.sessionStorage : window.localStorage;
      if (val === undefined) return st.getItem(key);
      if (val === null) { st.removeItem(key); return null; }
      st.setItem(key, val);
    } catch (e) { return null; }
  }
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function once(el, key) { if (el['__m_' + key]) return false; el['__m_' + key] = true; return true; }
  function within(scope, sel) {
    var list = $$(sel, scope);
    if (scope !== document && scope.matches && scope.matches(sel)) list.unshift(scope);
    return list;
  }

  /* ---------- Page transition ---------- */
  if (root.getAttribute('data-page-transition') === 'true' && !reduced && !design) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      if (/\/(checkout|cart\/|account|customer_authentication|password)/.test(url.pathname)) return;
      e.preventDefault();
      document.body.classList.add('is-leaving');
      setTimeout(function () { window.location.href = url.href; }, 220);
      setTimeout(function () { document.body.classList.remove('is-leaving'); }, 2500); // safety net
    });
    window.addEventListener('pageshow', function () { document.body.classList.remove('is-leaving'); });
  }

  /* ---------- Reveal on scroll ---------- */
  var SKIP = '[data-slideshow],.drawer,.modal,.popup,.header,.footer,.acc__body,[data-recent]';
  var RSEL = '.section__head,.rte,.tile,.banner,.post,.quote,.icons__item,.split__media,.split__text,.lookbook,.countdown,.acc,.mgrid__item,.story__text,.impact__stat,.videobanner__content,.grid>li';
  var rio = null;
  if (animate && root.getAttribute('data-reveal') === 'true') {
    var stagger = root.getAttribute('data-stagger') === 'true';
    rio = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var isGrid = el.parentElement && el.parentElement.classList.contains('grid');
        el.style.transitionDelay = (isGrid ? (stagger ? Math.min(n, 8) * 80 : 0) : Math.min(n, 4) * 90) + 'ms';
        n++;
        el.classList.add('is-revealed');
        rio.unobserve(el);
        var done = false;
        var clean = function () {
          if (done) return; done = true;
          el.classList.remove('will-reveal', 'is-revealed');
          el.style.transitionDelay = '';
        };
        el.addEventListener('transitionend', function te(ev) {
          if (ev.propertyName === 'opacity') { el.removeEventListener('transitionend', te); clean(); }
        });
        setTimeout(clean, 2200); // never leave content hidden
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
  }
  function scanReveal(scope) {
    if (!rio) return;
    var vh = window.innerHeight;
    within(scope, RSEL).forEach(function (el) {
      if (!once(el, 'reveal')) return;
      if (el.closest(SKIP)) return;
      var p = el.parentElement;
      if (p && p.closest(RSEL)) return;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 || r.width === 0) return; // already on screen, or hidden: leave it alone
      el.classList.add('will-reveal');
      rio.observe(el);
    });
  }
  /* Fast scrolling, the "End" key or anchor jumps can carry an element past the screen in one frame:
     the observer then never reports it, so reveal anything that is already above the bottom of the screen. */
  if (rio) {
    var catchUp = false;
    window.addEventListener('scroll', function () {
      if (catchUp) return;
      catchUp = true;
      window.requestAnimationFrame(function () {
        catchUp = false;
        var vh = window.innerHeight;
        $$('.will-reveal:not(.is-revealed)').forEach(function (el) {
          if (el.getBoundingClientRect().top < vh) {
            rio.unobserve(el);
            el.classList.add('is-revealed');
            setTimeout(function () { el.classList.remove('will-reveal', 'is-revealed'); el.style.transitionDelay = ''; }, 900);
          }
        });
        $$('.hd-pre:not(.is-in)').forEach(function (h) { if (h.getBoundingClientRect().top < vh) h.classList.add('is-in'); });
      });
    }, { passive: true });
  }
  /* Safety net: if anything is still hidden after the page is printed, show it. */
  window.addEventListener('beforeprint', function () { $$('.will-reveal').forEach(function (el) { el.classList.remove('will-reveal'); }); $$('.hd-pre').forEach(function (h) { h.classList.add('is-in'); }); });

  /* ---------- Animated headings ---------- */
  var mode = root.getAttribute('data-heading-anim') || 'none';
  var hio = (animate && mode !== 'none') ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      hio.unobserve(en.target);
    });
  }, { threshold: 0.2 }) : null;
  var HSEL = '.section__title,.page-head h1,.page-head h2,.banner__title,.impact__line,.revealed__title,.parallax__title,.story__text h2';
  function scanHeadings(scope) {
    if (!hio) return;
    within(scope, HSEL).forEach(function (h) {
      if (!once(h, 'head')) return;
      if (h.closest('[data-slideshow],.drawer,.modal,.popup')) return;
      var text = h.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;
      if (mode === 'words' && h.children.length === 0) {
        // screen readers read the hidden copy; the animated words are decoration
        h.innerHTML = '<span class="visually-hidden">' + esc(text) + '</span><span aria-hidden="true">' + text.split(' ').map(function (w, i) {
          return '<span class="w"><span class="w__in" style="transition-delay:' + Math.min(i, 12) * 70 + 'ms">' + esc(w) + '</span></span>';
        }).join(' ') + '</span>';
        h.classList.add('hd-pre');
      } else if (mode === 'mask') {
        h.classList.add('hd-mask', 'hd-pre');
      } else {
        h.classList.add('hd-fade', 'hd-pre');
      }
      hio.observe(h);
      setTimeout(function () { h.classList.add('is-in'); }, 6000); // never leave a heading hidden
    });
  }

  /* ---------- Scroll-linked effects (revealed image + parallax) ---------- */
  var fx = [];
  var ticking = false;
  function run() {
    ticking = false;
    var vh = window.innerHeight;
    fx = fx.filter(function (f) { return document.contains(f.el); });
    fx.forEach(function (f) {
      var r = f.el.getBoundingClientRect();
      if (r.bottom < -400 || r.top > vh + 400) return;
      f.fn(r, vh);
    });
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(run); } }
  var listening = false;
  function scanFx(scope) {
    if (reduced) return;
    within(scope, '[data-revealed]').forEach(function (el) {
      if (!once(el, 'fx')) return;
      fx.push({ el: el, fn: function (r, vh) {
        var span = r.height - vh;
        var p = span > 0 ? clamp(-r.top / span, 0, 1) : 1;
        var open = clamp(p / 0.55, 0, 1);
        var eased = 1 - Math.pow(1 - open, 3);
        el.style.setProperty('--p', eased.toFixed(3));
        el.style.setProperty('--tp', clamp((p - 0.35) / 0.4, 0, 1).toFixed(3));
      } });
    });
    within(scope, '[data-parallax]').forEach(function (el) {
      if (!once(el, 'fx')) return;
      var img = $('.parallax__img', el);
      var strength = parseFloat(el.getAttribute('data-strength')) || 0.14;
      if (!img) return;
      fx.push({ el: el, fn: function (r, vh) {
        var off = (r.top + r.height / 2) - vh / 2;
        var limit = r.height * 0.14;
        img.style.transform = 'translate3d(0,' + clamp(-off * strength, -limit, limit).toFixed(1) + 'px,0)';
      } });
    });
    if (fx.length && !listening) {
      listening = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    if (fx.length) run();
  }

  /* ---------- Scrolling images + text ---------- */
  function scanStory(scope) {
    within(scope, '[data-story]').forEach(function (el) {
      if (!once(el, 'story')) return;
      var items = $$('[data-story-item]', el);
      var imgs = $$('[data-story-img]', el);
      var counter = $('[data-story-current]', el);
      if (items.length < 2 || !hasIO) return;
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = items.indexOf(en.target);
          imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
          if (counter) counter.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      items.forEach(function (it) { sio.observe(it); });
    });
  }

  /* ---------- Count-up numbers ---------- */
  var nf;
  try { nf = new Intl.NumberFormat(root.lang || undefined); } catch (e) { nf = { format: String }; }
  function scanCounters(scope) {
    var counters = within(scope, '[data-count]').filter(function (el) { return once(el, 'count'); });
    if (!counters.length) return;
    if (!hasIO || reduced) { counters.forEach(function (el) { var t = parseFloat(el.getAttribute('data-count')); if (!isNaN(t)) el.textContent = nf.format(t); }); return; }
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        cio.unobserve(el);
        var target = parseFloat(el.getAttribute('data-count'));
        if (isNaN(target)) return;
        var start = null, dur = 1600;
        function step(ts) {
          if (start === null) start = ts;
          var t = clamp((ts - start) / dur, 0, 1);
          el.textContent = nf.format(Math.round(target * (1 - Math.pow(1 - t, 3))));
          if (t < 1) window.requestAnimationFrame(step); else el.textContent = nf.format(target);
        }
        window.requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { el.textContent = '0'; cio.observe(el); });
  }

  /* ---------- Recently viewed ---------- */
  var KEY = 'bego_recent';
  function readRecent() {
    try { var l = JSON.parse(store(KEY) || '[]'); return Array.isArray(l) ? l.filter(function (h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9\-_%]*$/i.test(h); }) : []; } catch (e) { return []; }
  }
  var currentEl = $('[data-product-handle]');
  var currentHandle = currentEl ? currentEl.getAttribute('data-product-handle') : null;
  if (currentHandle) {
    var list = readRecent().filter(function (h) { return h !== currentHandle; });
    list.unshift(currentHandle);
    store(KEY, JSON.stringify(list.slice(0, 12)));
  }
  function scanRecent(scope) {
    within(scope, '[data-recent]').forEach(function (el) {
      if (!once(el, 'recent')) return;
      var limit = parseInt(el.getAttribute('data-limit'), 10) || 4;
      var handles = readRecent().filter(function (h) { return h !== currentHandle; }).slice(0, limit);
      var ul = $('[data-recent-list]', el);
      if (!handles.length || !ul) return;
      Promise.all(handles.map(function (h) {
        return fetch(rootUrl + 'products/' + encodeURIComponent(h) + '?section_id=recent-card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (htmls) {
        var out = '';
        htmls.forEach(function (html) {
          if (!html) return;
          var card = new DOMParser().parseFromString(html, 'text/html').querySelector('.card');
          if (card) out += '<li>' + card.outerHTML + '</li>';
        });
        if (out) { ul.innerHTML = out; el.hidden = false; }
      });
    });
  }

  /* ---------- Newsletter popup (settings: Theme settings > Newsletter popup) ---------- */
  function initPopup(pop) {
    if (!once(pop, 'popup')) return;
    var PK = 'bego_popup_closed', SUBK = 'bego_popup_subscribed', SENTK = 'bego_popup_sent';
    var d = pop.dataset;
    var delay = Math.max(0, parseInt(d.delay, 10) || 0);
    var days = parseInt(d.days, 10) || 7;
    var panel = $('.popup__panel', pop);
    var form = $('form', pop);
    var opener = null, shown = false;
    function lock(on) { root.classList.toggle('is-locked', !!on); }
    function isOpen() { return pop.classList.contains('is-open'); }
    function open(force) {
      if (shown && !force) return;
      if (!force && $('.drawer.is-open,.modal.is-open')) { setTimeout(function () { open(); }, 4000); return; }
      shown = true;
      opener = document.activeElement;
      pop.hidden = false;
      pop.setAttribute('aria-hidden', 'false');
      lock(true);
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
      var focusEl = $('input[type="email"]', pop) || $('.popup__close', pop);
      if (focusEl && !design) setTimeout(function () { try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); } }, 380);
    }
    function close() {
      if (!isOpen()) return;
      pop.classList.remove('is-open');
      pop.setAttribute('aria-hidden', 'true');
      if (!design) store(PK, String(Date.now()));
      if (!$('.drawer.is-open,.modal.is-open')) lock(false);
      setTimeout(function () { if (!isOpen()) pop.hidden = true; }, 380);
      if (opener && opener.focus && document.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    }
    pop.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
    if (form) form.addEventListener('submit', function () { store(SENTK, '1', true); });

    if (design) { if (d.preview === 'true') open(true); return; }

    // The visitor just submitted this popup's form: show the thank-you or the error message
    if (store(SENTK, undefined, true)) {
      store(SENTK, null, true);
      if ($('[data-popup-success]', pop)) store(SUBK, '1');
      open(true);
      return;
    }
    if ($('[data-popup-success]', pop)) { store(SUBK, '1'); return; } // subscribed through another form
    if (store(SUBK)) return;
    var last = parseInt(store(PK), 10);
    if (last && Date.now() - last < days * 864e5) return;
    var isPhone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (isPhone && d.mobile !== 'true') return;
    if (d.pages === 'home') {
      var path = window.location.pathname.replace(/\/+$/, '/') || '/';
      if (path !== rootUrl && path !== '/' && path + '/' !== rootUrl) return;
    }

    var trigger = d.trigger || 'delay';
    var canExit = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (trigger === 'exit' && !canExit) trigger = 'delay'; // phones have no "leaving" gesture: fall back to the timer
    if (trigger === 'scroll') {
      var pct = (parseInt(d.scroll, 10) || 40) / 100;
      var onS = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0 || window.scrollY / max >= pct) { window.removeEventListener('scroll', onS); open(); }
      };
      window.addEventListener('scroll', onS, { passive: true });
    } else if (trigger === 'exit') {
      var onOut = function (e) {
        if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open(); }
      };
      setTimeout(function () { document.addEventListener('mouseout', onOut); }, 3000);
    } else {
      setTimeout(function () { open(); }, delay * 1000);
    }
  }

  /* ---------- Shop-the-look: keep the product card on screen ---------- */
  function fitPin(e) {
    var pin = e.target.closest && e.target.closest('.pin');
    if (!pin) return;
    var card = $('.pin__card', pin);
    if (!card) return;
    card.style.setProperty('--shift', '0px');
    var r = card.getBoundingClientRect(), vw = document.documentElement.clientWidth, shift = 0;
    if (r.left < 8) shift = 8 - r.left;
    else if (r.right > vw - 8) shift = (vw - 8) - r.right;
    card.style.setProperty('--shift', shift + 'px');
  }
  document.addEventListener('mouseover', fitPin);
  document.addEventListener('focusin', fitPin);

  /* ---------- Init + theme editor support ---------- */
  function scan(scope) {
    scope = scope || document;
    scanReveal(scope);
    scanHeadings(scope);
    scanFx(scope);
    scanStory(scope);
    scanCounters(scope);
    scanRecent(scope);
  }
  scan(document);
  $$('[data-popup]').forEach(initPopup);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
